// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { setServicesIaListRedux, setServiceIaRedux } from './servicesIaSlice';
import {
  getAllServicesIaService,
  getServicesIaByIdService,
  createServicesIaService,
  updateServicesIaService,
  deleteServicesIaService,
  restoreServicesIaService,
} from '../../services/servicesIa.service';
import { QueryPagination } from '../../commons/interfaces';

export const getAllServicesIaStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await getAllServicesIaService(query);

      if (response.ok) {
        await dispatch(setServicesIaListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getServiceIaByIdStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await getServicesIaByIdService(id);

    if (response.ok) {
      dispatch(setServiceIaRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const saveServiceIaStore = (data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await createServicesIaService(data);

    if (response.ok) {
      dispatch(setServicesIaListRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const editServiceIaStore = (id: string, data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await updateServicesIaService(id, data);

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const deleteServiceIaStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await deleteServicesIaService(id, query);

      if (response.ok) {
        dispatch(setServicesIaListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restoreServiceIaStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await restoreServicesIaService(id, query);

      if (response.ok) {
        dispatch(setServicesIaListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
